import type { CognitoPasswordResetFailureResult } from './WorkyCognitoAuthServiceInterfaces';

const COGNITO_UNVERIFIED_CONTACT_RESET_ERROR_FRAGMENT: string =
    'no registered/verified email or phone_number';

const isUnverifiedContactPasswordResetFailure = (
    input: CognitoPasswordResetFailureResult
): boolean => input.errorMessage
    .toLowerCase()
    .includes(COGNITO_UNVERIFIED_CONTACT_RESET_ERROR_FRAGMENT);

export {
    isUnverifiedContactPasswordResetFailure,
};
